import { render, staticRenderFns } from "./9.vue?vue&type=template&id=4642413d&scoped=true&"
var script = {}
import style0 from "./9.vue?vue&type=style&index=0&id=4642413d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4642413d",
  null
  
)

export default component.exports